var $ = require('jQuery');
var Vue = require('vue');
var AttachmentTypes = require('../../lib/attachment-types.js');
var AccessMatrix = require('./access-matrix.js');
var Multiselect = require('vue-bootstrap').Multiselect;

module.exports = function() {
    /**
     * Toggle options
     */
    var toggleOptions = function() {
        $('.toggle-block').addClass('hidden');

        $('.toggle-options').each(function() {
            if ($(this).prop('checked')) {
                $('.toggle-only-'+$(this).attr('id')).removeClass('hidden');
            }
        });
    };

    // Bind and fire on load
    $('.toggle-options').on('change', toggleOptions);

    toggleOptions();

    // Access matrix
    new AccessMatrix();

    // Initialise attachment types toggles
    new AttachmentTypes();

    // Category selector
    new Vue({
        el: '#category-selector',
        components: {
            'multiselect': Multiselect
        }
    });
};
